<div style="position: relative; height: 100%">
  <button mat-icon-button mat-dialog-close style="position:absolute;right:0;top:0;z-index: 1000" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
  <div mat-dialog-content class="center-text">
    <div class="title-green">Merci d'avoir réalisé Mon Bilan Prévoyance</div>
    <div class="title-green">Vous allez rapidement être recontacté(e) par un conseiller.</div>
  </div>
</div>
